import React, { useState } from 'react';

function Star({ filled, half, size, onClick, onMouseEnter, interactive }) {
  return (
    <svg
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      className={`${size} ${interactive ? 'cursor-pointer' : ''} ${filled ? 'text-amber-400' : 'text-gray-300'}`}
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={filled ? 0 : 1.5}
      viewBox="0 0 24 24"
    >
      <path d="M12 2.5l2.9 6.26 6.9.79-5.13 4.78 1.4 6.83L12 17.6l-6.07 3.56 1.4-6.83L2.2 9.55l6.9-.79L12 2.5z" />
    </svg>
  );
}

/** Read-only star display for an average score (supports halves via two-layer render). */
export function StarDisplay({ value = 0, size = 'w-4 h-4' }) {
  const rounded = Math.round((value || 0) * 2) / 2;
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} filled={n <= rounded} size={size} interactive={false} />
      ))}
    </div>
  );
}

/** Interactive star picker for submitting a rating. */
export default function StarRating({ value = 0, onChange, size = 'w-7 h-7' }) {
  const [hover, setHover] = useState(0);
  const active = hover || value;
  return (
    <div className="flex items-center gap-1" onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          filled={n <= active}
          size={size}
          interactive
          onMouseEnter={() => setHover(n)}
          onClick={() => onChange(n)}
        />
      ))}
    </div>
  );
}
